import { render, staticRenderFns } from "./OrderTotalDetails.vue?vue&type=template&id=8d639c18&"
import script from "./OrderTotalDetails.vue?vue&type=script&lang=js&"
export * from "./OrderTotalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports